const targetNode = document.querySelector('.hs-site-cart-popup-layout');

if (!targetNode) {
  throw new Error('Element .hs-site-cart-popup-layout not found');
}

const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (!mutation.addedNodes.length) continue;

    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) {

        const slide = node.matches(
          '.hs-products-dynamic-stacked .hs-swiper-slide, .hs-products-stacked .hs-swiper-slide'
        )
          ? node
          : node.querySelector?.(
            '.hs-products-dynamic-stacked .hs-swiper-slide, .hs-products-stacked .hs-swiper-slide'
          );

        if (slide) {

          const firstChild = slide.querySelector('.hs-content-title-price-swiper')?.firstElementChild;
          //console.log('firstChild', firstChild);
          if (firstChild) {

            if (slide && !slide.classList.contains('hs-is-processed')) {

              const elementMovePrices = firstChild.querySelector(
                '.hs-content-price-swiper'
              );

              const elementMoveOptions = firstChild.querySelector(
                '.hs-options-swiper'
              );

              const destination = firstChild.querySelector(
                '.hs-title-swiper'
              );

              if (destination) {
                if (elementMovePrices) {
                  destination.appendChild(elementMovePrices);
                }
                if (elementMoveOptions) {
                  destination.appendChild(elementMoveOptions);
                }

                slide.classList.add('hs-is-processed');

                // console.log('slide process check');
              }
            }
          }
        }
      }
    });
  }
});

observer.observe(targetNode, {
  childList: true,
  subtree: true
});